import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { ModalComponent } from './modal.component';

@NgModule({
  imports: [CommonModule, TranslateModule],
  declarations: [ModalComponent],
  exports: [ModalComponent],
  providers: [],
})
export class ModalComponentModule {}
